export default "__VITE_ASSET__DEmDIDLB__"